import React, { useEffect, useState, useCallback } from 'react';
import { Box } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import baseURL from '../../user/config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EmailSender from './SendEmail/SendEmail';
import PageLoader from '../../../Reusable/PageLoader';

const SendEmailPage = () => {
    const [allDonors, setAllDonors] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchAllData = useCallback(async () => {
        setLoading(true);
        try {
             //   await new Promise(resolve => setTimeout(resolve, 4000));

            // Fetch donors and campaigns concurrently
            const [resDonors, resCampaigns] = await Promise.all([
                fetch(`${baseURL}/org/all-donors`, { credentials: 'include' }),
                fetch(`${baseURL}/org/orgcampaigns`, { credentials: 'include' })
            ]);

            // Parse JSON concurrently
            const [donorsData, campaignsData] = await Promise.all([
                resDonors.json(),
                resCampaigns.json()
            ]);

            // Check for errors
            if (!resDonors.ok) throw new Error(donorsData.message || 'Failed to fetch donors');
            if (!resCampaigns.ok) throw new Error(campaignsData.message || 'Failed to fetch campaigns');

            // Update state
            setAllDonors(donorsData.donors || []);
            setCampaigns(campaignsData.campaigns || []);
        } catch (err) {
            // Display all errors via toast
            toast.error(err.message || 'Failed to load data');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]);

    return (
        <DashboardLayout>
            {loading && <PageLoader />}

            {!loading && (
                <Box sx={{ p: 3 }}>
                    <EmailSender
                        allDonors={allDonors}
                        campaigns={campaigns}
                        fetchAllDonors={fetchAllData} // refetch both donors & campaigns
                    />
                </Box>
            )}
        </DashboardLayout>
    );
};

export default SendEmailPage;
